import { baseStyles, defaultPanelStyles } from '../base-styles';

export function getStyles(accent: string, position: string): string {
  const right = position === 'bottom-right';
  return baseStyles(accent) + defaultPanelStyles(position) + `
    .yd-bubble {
      position: fixed;
      bottom: 16px;
      ${right ? 'right: 20px;' : 'left: 20px;'}
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background: ${accent};
      color: white;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      transition: transform 0.2s, box-shadow 0.2s;
      z-index: 1;
      pointer-events: auto;
    }
    .yd-bubble:hover {
      transform: scale(1.05);
      box-shadow: 0 6px 20px rgba(0,0,0,0.2);
    }
  `;
}
